import OtpEntry from '@shared/components/auth/OtpEntry';

const AdminOtp = () => {
	return <OtpEntry />;
};

export default AdminOtp;
